module.exports = __webpack_public_path__ + "assets/webgl/LM_2_1.202a9512.jpg";